import { simpleSet } from '@r/reducers/utils';

const setCalculationModeShippingCostManualLabel = simpleSet as
  redux.reducers.calculationMode.settings.information.shippingCostManual.label;

export const label = setCalculationModeShippingCostManualLabel(
  'SET_CALCULATION_MODE_SHIPPING_COST_MANUAL_LABEL',
  ''
);
